// 
// index.js
// cenit-website
// 
// Created by Matías Martínez on 21/8/25
// 
// 
// App.js
// cenit-website
// 
// Created by Matías Martínez on 21/8/25
// 
// 
// HighlighterEffect.js
// cenit-website
// 
// Created by Matías Martínez on 21/8/25
// 
class $f37a1533010a55b8$var$HighlighterEffect {
    constructor({ node: node, seed: seed = Date.now(), jitter: jitter = 10 } = configuration){
        this.timing = {
            duration: 500,
            easing: "ease-in-out",
            fill: "forwards"
        };
        this.node = node;
        this.seed = seed;
        this.jitter = jitter; // how “wiggly” the curve should be (px)
    }
    // tiny seeded PRNG (Mulberry32)
    rand() {
        let t = this.seed += 0x6D2B79F5;
        t = Math.imul(t ^ t >>> 15, t | 1);
        t ^= t + Math.imul(t ^ t >>> 7, t | 61);
        return ((t ^ t >>> 14) >>> 0) / 4294967296;
    }
    // random in [-range, +range]
    r(range) {
        return (this.rand() * 2 - 1) * range;
    }
    // Build a smooth-ish cubic path that stays inside the viewBox
    makePathD({ w: w = 194, h: h = 50 } = {}) {
        const cx = (x)=>x; // keep x linear
        const cyBase = h * 0.5; // baseline mid-height
        const amp = Math.min(this.jitter, h * 0.45); // don’t clip the big stroke
        // Start and end x positions
        const x0 = 2, x3 = w - 2;
        // Random vertical offsets around the center line
        const y0 = cyBase + this.r(amp * 0.4);
        const y1 = cyBase + this.r(amp);
        const y2 = cyBase + this.r(amp);
        const y3 = cyBase + this.r(amp * 0.4);
        // Control points spaced roughly at 1/3 and 2/3 of width
        const c1x = w * 0.33, c2x = w * 0.66;
        // Slight randomization to control-point x as well
        const c1xr = c1x + this.r(w * 0.05);
        const c2xr = c2x + this.r(w * 0.05);
        return `M${cx(x0)} ${y0} C ${c1xr} ${y1}, ${c2xr} ${y2}, ${cx(x3)} ${y3}`;
    }
    render() {
        const w = 194, h = 50;
        const d = this.makePathD({
            w: w,
            h: h
        });
        const body = `<svg preserveAspectRatio="none" width="${w}" height="${h}" viewBox="0 0 ${w} ${h}" fill="none" xmlns="http://www.w3.org/2000/svg"><path class="path" opacity="0.2" d="${d}" stroke="#FB5E15" stroke-width="40" stroke-linecap="round" fill="none"/></svg>`;
        const containerNode = document.createElement("span");
        containerNode.className = "highlighter";
        containerNode.innerHTML = body;
        this.node.appendChild(containerNode);
        this.path = containerNode.querySelector(".path");
    }
    animate() {
        if (!this.isPrepared) {
            this.render();
            this.isPrepared = true;
        }
        const { node: node, path: path, timing: timing } = this;
        const length = path.getTotalLength();
        const animations = [
            path.animate([
                {
                    strokeDasharray: length,
                    strokeDashoffset: length
                },
                {
                    strokeDasharray: length,
                    strokeDashoffset: 0
                }
            ], timing),
            node.animate([
                {
                    backgroundPosition: "0 0"
                },
                {
                    backgroundPosition: "-100% 0"
                }
            ], timing)
        ];
        return Promise.all(animations.map((a)=>a.finished));
    }
}
var $f37a1533010a55b8$export$2e2bcd8739ae039 = $f37a1533010a55b8$var$HighlighterEffect;


// 
// Ticker.js
// cenit-website
// 
// Created by Matías Martínez on 21/8/25
// 
class $8f969c6b1ebda1f3$export$d7fd9566a67ce504 {
    // UIScrollViewDecelerationRateNormal
    static normal = 0.998;
    // UIScrollViewDecelerationRateFast
    static fast = 0.99;
}
class $8f969c6b1ebda1f3$var$TickerMode {
    // Automatically scrolling or resting (when prefers-reduced-motion):
    static auto = "auto";
    // User is dragging:
    static dragging = "dragging";
    // User has lifted and we're decelerating:
    static decelerating = "decelerating";
}
class $8f969c6b1ebda1f3$export$ee82664b7008a11d {
    constructor({ node: // The target node:
    node, speed: // Speed for automatic scrolling:
    speed = 40, direction: // Direction of automatic scrolling:
    direction = 1, decelerationRate: // The deceleration rate for user-interactive scrolling:
    decelerationRate = $8f969c6b1ebda1f3$export$d7fd9566a67ce504.normal, animatesImmediately: // Determines if the animation starts right away:
    animatesImmediately = true, smoothing: // Smoothing parameters for decelerating:
    smoothing = {
        tau: 0.18,
        aMax: 6000,
        jMax: 40000,
        snapEps: 1.2
    } } = {}){
        this.node = node;
        this.speed = speed;
        this.direction = Math.sign(direction) || 1;
        this.decelerationRate = decelerationRate;
        this.blend = smoothing;
        // Sizes:
        this.contentSize = {
            width: 0,
            height: 0
        };
        this.gap = 0;
        // The original nodes and clones:
        this.scrollingNodes = [
            ...node.children
        ];
        this.repeatingNodes = [];
        // Unwrapped physics state:
        this.uOffset = 0;
        this.offset = 0;
        this.vx = 0;
        this.mode = $8f969c6b1ebda1f3$var$TickerMode.auto;
        // Animation tokens:
        this._request = null;
        this._lastTimestamp = null;
        // Drag + velocity sampler:
        this._drag = {
            active: false,
            lastX: 0,
            lastT: 0,
            samples: []
        };
        // Blend state:
        this._a = 0; // acceleration tracker for jerk-limited blending
        // Compositor + gesture hints:
        const { style: style } = node;
        style.willChange = "transform";
        style.userSelect = "none";
        style.touchAction = "pan-y";
        this._reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        // Add event handlers:
        window.addEventListener("resize", this.invalidateContainerSize.bind(this));
        this.node.addEventListener("pointerdown", this._onPointerDown.bind(this), {
            passive: false
        });
        window.addEventListener("pointermove", this._onPointerMove.bind(this), {
            passive: false
        });
        window.addEventListener("pointerup", this._onPointerUp.bind(this));
        window.addEventListener("pointercancel", this._onPointerUp.bind(this));
        // Init:
        const init = ()=>{
            this.invalidateContainerSize();
            if (animatesImmediately) this.start();
        };
        window.requestAnimationFrame(init);
    }
    layout() {
        this.invalidateContentSizeIfNeeded();
        const containerW = this.containerSize.width;
        const neededRepeats = Math.ceil(containerW / this.contentSize.width) + 1;
        const repeatCount = Math.max(neededRepeats, 2);
        if (this.repeatCount === repeatCount) return;
        this.repeatingNodes.forEach((n)=>n.parentNode && n.parentNode.removeChild(n));
        const fragment = document.createDocumentFragment();
        for(let i = 0; i < repeatCount; i++)this.scrollingNodes.map((n)=>n.cloneNode(true)).forEach((n)=>fragment.appendChild(n));
        this.node.appendChild(fragment);
        this.repeatCount = repeatCount;
        this.repeatingNodes = [
            ...fragment.childNodes
        ];
    }
    invalidateContentSizeIfNeeded() {
        if (this.contentSize.width <= 0) this.invalidateContentSize();
    }
    invalidateContentSize() {
        const { node: node } = this;
        this.contentSize = node.getBoundingClientRect();
        this.gap = parseFloat(getComputedStyle(node).rowGap);
    }
    invalidateContainerSize() {
        this.containerSize = this.node.parentNode.getBoundingClientRect();
        this.layout();
    }
    // Velocity sampler:
    _addSample(x) {
        const sampleWindowDuration = 50;
        const now = Date.now();
        this._drag.samples.push({
            x: x,
            time: now
        });
        const expiry = now - sampleWindowDuration;
        const q = this._drag.samples;
        while(q.length && q[0].time < expiry)q.shift();
    }
    _computeVelocityOffsetSpace() {
        const velocityWindowDuration = 1000;
        const expiry = Date.now() - velocityWindowDuration;
        const q = this._drag.samples;
        while(q.length && q[0].time < expiry)q.shift();
        if (q.length < 2) return 0;
        const first = q[0], last = q[q.length - 1];
        const dt = (last.time - first.time) / 1000;
        if (dt <= 0) return 0;
        const dxPointer = last.x - first.x;
        return -(dxPointer / dt);
    }
    // Gestures:
    _onPointerDown(e) {
        if (e.button != null && e.button !== 0) return;
        e.preventDefault();
        this.node.setPointerCapture?.(e.pointerId);
        this.mode = $8f969c6b1ebda1f3$var$TickerMode.dragging;
        this.vx = 0;
        this._drag.active = true;
        this._drag.lastX = e.clientX;
        this._drag.lastT = performance.now();
        this._drag.samples.length = 0;
        this._addSample(e.clientX);
        if (!this._request) {
            this._lastTimestamp = null;
            this._request = requestAnimationFrame(this.frame.bind(this));
        }
    }
    _onPointerMove(e) {
        if (!this._drag.active) return;
        const dx = e.clientX - this._drag.lastX;
        this.uOffset -= dx;
        this._addSample(e.clientX);
        this._drag.lastX = e.clientX;
        this._drag.lastT = performance.now();
        this._display();
    }
    _onPointerUp(_e) {
        if (!this._drag.active) return;
        this._drag.active = false;
        let v = this._computeVelocityOffsetSpace();
        const maximumFlingVelocity = 2000;
        v = Math.max(-maximumFlingVelocity, Math.min(maximumFlingVelocity, v));
        this.vx = v;
        if (Math.abs(this.vx) > 1) this.direction = this.vx >= 0 ? 1 : -1;
        if (this._reducedMotion) {
            this.mode = $8f969c6b1ebda1f3$var$TickerMode.auto;
            return;
        }
        this._a = 0; // reset accel for blend
        this.mode = $8f969c6b1ebda1f3$var$TickerMode.decelerating;
    }
    // ----- RAF -----
    frame(ts) {
        if (this._lastTimestamp == null) this._lastTimestamp = ts;
        const dt = Math.min(0.05, (ts - this._lastTimestamp) / 1000);
        this._lastTimestamp = ts;
        if (this.mode === $8f969c6b1ebda1f3$var$TickerMode.auto && !this._reducedMotion) this.uOffset += this.speed * dt * this.direction;
        else if (this.mode === $8f969c6b1ebda1f3$var$TickerMode.decelerating) {
            const vAuto = this.speed * this.direction;
            const { tau: tau = 0.18, aMax: aMax = 6000, jMax: jMax = 40000, snapEps: snapEps = 1.2 } = this.blend;
            // desired accel
            const aDes = (vAuto - this.vx) / Math.max(0.001, tau);
            // jerk limit
            const aDeltaMax = jMax * dt;
            const aNextUnclamped = Math.abs(aDes - this._a) > aDeltaMax ? this._a + Math.sign(aDes - this._a) * aDeltaMax : aDes;
            // clamp accel
            this._a = Math.max(-aMax, Math.min(aMax, aNextUnclamped));
            this.vx += this._a * dt;
            this.uOffset += this.vx * dt;
            if (Math.abs(this.vx - vAuto) < snapEps && Math.abs(this._a) < aMax * 0.05) {
                this.vx = vAuto;
                this._a = 0;
                this.mode = $8f969c6b1ebda1f3$var$TickerMode.auto;
            }
        }
        this._display();
        this._request = requestAnimationFrame(this.frame.bind(this));
    }
    // 
    _display() {
        const w = this.contentSize.width + this.gap || 1;
        this.offset = (this.uOffset % w + w) % w;
        const x = -this.offset;
        this.node.style.transform = new DOMMatrix().translate(x, 0);
    }
    start() {
        if (this._request || this._reducedMotion) return;
        this._lastTimestamp = null;
        this._request = requestAnimationFrame(this.frame.bind(this));
    }
    stop() {
        if (this._request) cancelAnimationFrame(this._request);
        this._request = null;
    }
}
var $8f969c6b1ebda1f3$export$2e2bcd8739ae039 = $8f969c6b1ebda1f3$export$ee82664b7008a11d;


// 
// ContentReadiness.js
// cenit-website
// 
// Created by Matías Martínez on 22/8/25
// 
class $accd4668ba4d214f$var$ContentReadiness {
    async waitForImagesInElement(container) {
        const images = Array.from(container.querySelectorAll("img"));
        // Bridge with a Promise for each image
        const promises = images.map((img)=>{
            if (img.complete) return Promise.resolve();
            else if (img.decode) // Modern browsers
            return img.decode().catch(()=>{}); // swallow errors (broken images)
            else // Fallback for older browsers
            return new Promise((resolve)=>{
                img.addEventListener("load", resolve, {
                    once: true
                });
                img.addEventListener("error", resolve, {
                    once: true
                });
            });
        });
        await Promise.all(promises);
    }
    async waitForAnimationsInElement(element) {
        if ("getAnimations" in element) {
            const activeAnimations = element.getAnimations({
                subtree: true
            });
            if (activeAnimations.length === 0) return;
            console.log(activeAnimations);
            const animationPromises = activeAnimations.map((animation)=>animation.finished.catch(()=>{}));
            await Promise.all(animationPromises);
        } else // Fallback: wait a fixed delay
        await this.fixedDelay(seconds);
    }
    async waitForFixedDelay(seconds1) {
        return new Promise((resolve)=>setTimeout(resolve, seconds1 * 1000));
    }
    async waitForAllFonts() {
        // https://gomakethings.com/a-modern-font-loading-strategy-with-the-vanilla-js-fontfaceset.load-method/
        // Fast-path if cookie was set:
        const fastPathCookieName = "fontsLoaded";
        const fastPathEnabled = false;
        if (this.readCookie(fastPathCookieName) && fastPathEnabled) return;
        if (!("fonts" in document)) return;
        // Built-in promise:
        await document.fonts.ready;
        const expires = new Date(+new Date() + 604800000);
        this.writeCookie(fastPathCookieName, true, expires);
    }
    readCookie(name) {
        var value = "; " + document.cookie;
        var parts = value.split("; " + name + "=");
        if (parts.length == 2) return parts.pop().split(";").shift();
    }
    writeCookie(name, value, expires) {
        document.cookie = `${name}=${value}; expires=${expires.toUTCString()}`;
    }
}
var $accd4668ba4d214f$export$2e2bcd8739ae039 = $accd4668ba4d214f$var$ContentReadiness;


class $393a7531d1c5048f$var$DocumentStateClassName {
    static js = "js";
    static done = "done";
    static firstImagesDone = "first-images-done";
}
class $393a7531d1c5048f$var$App {
    constructor(document1){
        this.appendDocumentClassName($393a7531d1c5048f$var$DocumentStateClassName.js);
        document1.addEventListener("DOMContentLoaded", this.awake.bind(this));
    }
    appendDocumentClassName(name) {
        document.documentElement.classList.add(name);
    }
    async awake() {
        const readiness = new (0, $accd4668ba4d214f$export$2e2bcd8739ae039)(document);
        await readiness.waitForAllFonts();
        this.appendDocumentClassName($393a7531d1c5048f$var$DocumentStateClassName.done);
        await readiness.waitForAnimationsInElement(document.body);
        this.addEffects();
        await readiness.waitForImagesInElement(document.querySelector(".tidbits"));
        this.appendDocumentClassName($393a7531d1c5048f$var$DocumentStateClassName.firstImagesDone);
    }
    addEffects() {
        // Highlighter effects:
        const highlightable = document.querySelectorAll("[data-highlighter] em");
        const animate = async ()=>{
            for (const node of [
                ...highlightable
            ]){
                const effect = new (0, $f37a1533010a55b8$export$2e2bcd8739ae039)({
                    node: node
                });
                await effect.animate();
            }
        };
        window.requestAnimationFrame(animate);
        // Ticker effect for tidbits:
        const animatableByTicker = document.querySelectorAll(".tidbits .items");
        this.animators = [
            ...animatableByTicker
        ].map((node)=>new (0, $8f969c6b1ebda1f3$export$2e2bcd8739ae039)({
                node: node
            }));
    }
}
var $393a7531d1c5048f$export$2e2bcd8739ae039 = $393a7531d1c5048f$var$App;


const $1ef9dc4ee2985d4e$var$app = new (0, $393a7531d1c5048f$export$2e2bcd8739ae039)(document);
window.app = $1ef9dc4ee2985d4e$var$app;


//# sourceMappingURL=es-CL.5e2c98d1.js.map
